export const platform = {
  Facebook: 'Facebook',
  LiveChat: 'Livechat',
  Viber: 'Viber',
};
